import { render, staticRenderFns } from "./BookingInformationForm.vue?vue&type=template&id=18dd82ba&"
import script from "./BookingInformationForm.vue?vue&type=script&lang=js&"
export * from "./BookingInformationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports